export function isWebAuthnSupported() {
  return !!window.PublicKeyCredential;
}

export async function isBiometricAvailable() {
  if (!window.PublicKeyCredential) return false;
  try {
    return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch {
    return false;
  }
}

function base64UrlDecode(str) {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

function base64UrlEncode(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function getStoredCredential() {
  try {
    const stored = localStorage.getItem('webauthn_credential');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

// Armazena apenas email e companyId — o credentialId não é necessário no frontend
// (o servidor retorna a lista de credenciais válidas via allowCredentials)
export function storeCredential(email, companyId) {
  localStorage.setItem(
    'webauthn_credential',
    JSON.stringify({ email, companyId })
  );
}

export function clearCredential() {
  localStorage.removeItem('webauthn_credential');
}

export async function createCredential(optionsFromServer) {
  const publicKey = {
    ...optionsFromServer,
    challenge: base64UrlDecode(optionsFromServer.challenge),
    user: {
      ...optionsFromServer.user,
      id: base64UrlDecode(optionsFromServer.user.id),
    },
    excludeCredentials: (optionsFromServer.excludeCredentials || []).map((c) => ({
      ...c,
      id: base64UrlDecode(c.id),
    })),
    // Força autenticador de plataforma (Touch ID, Face ID, Windows Hello)
    authenticatorSelection: {
      authenticatorAttachment: 'platform',
      userVerification: 'preferred',
      requireResidentKey: false,
    },
  };

  const credential = await navigator.credentials.create({ publicKey });

  return {
    id: credential.id,
    rawId: base64UrlEncode(credential.rawId),
    type: credential.type,
    response: {
      attestationObject: base64UrlEncode(credential.response.attestationObject),
      clientDataJSON: base64UrlEncode(credential.response.clientDataJSON),
    },
  };
}

export async function getCredential(optionsFromServer) {
  const publicKey = {
    ...optionsFromServer,
    challenge: base64UrlDecode(optionsFromServer.challenge),
    allowCredentials: (optionsFromServer.allowCredentials || []).map((c) => ({
      ...c,
      id: base64UrlDecode(c.id),
    })),
  };

  const assertion = await navigator.credentials.get({ publicKey });

  return {
    id: assertion.id,
    rawId: base64UrlEncode(assertion.rawId),
    type: assertion.type,
    response: {
      authenticatorData: base64UrlEncode(assertion.response.authenticatorData),
      clientDataJSON: base64UrlEncode(assertion.response.clientDataJSON),
      signature: base64UrlEncode(assertion.response.signature),
      userHandle: assertion.response.userHandle
        ? base64UrlEncode(assertion.response.userHandle)
        : null,
    },
  };
}
